module.exports = __webpack_public_path__ + "static/media/temple.3c0509e6.jpg";